import React from 'react';
import classNames from 'classnames';
import styles from '../styles/flag_icon.module.scss';

interface FlagIconProps extends React.ComponentPropsWithoutRef<'img'> {
  countryCode: string;
  size?: string | number;
}

export default function FlagIcon({countryCode, size, className, src, ...others}: FlagIconProps) {
  const imageSrc = `https://purecatamphetamine.github.io/country-flag-icons/3x2/${countryCode}.svg`;
  const containerClass = classNames(styles.container, className);

  let heightStyle: string | undefined = undefined;
  if (size) {
    if (typeof size === 'string') {
      heightStyle =  size;
    } else {
      heightStyle = `${size}px`;
    }
  }
  return <img alt={countryCode} src={imageSrc} className={containerClass} style={{
    height: heightStyle
  }} {...others} />
}